// extracted by mini-css-extract-plugin
module.exports = {"Welcome":"Welcome_Welcome__1MYvk","Wrap":"Welcome_Wrap__1ycnt","Description":"Welcome_Description__324Vt"};